import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, useLocation, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { FillFilters, FormatPhoneNumber, loadLookupFromDataSource } from '../../../../common/Utils'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "90561F7B-27C9-4DB4-96A0-CA96BE4C5FFC";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    // The Item Kit Data Profile form's "Item Kit Codes" button arrives with ?profileCode=..., the
    // migrated form of Delphi frmWMD0102.SetParameters(<profile rowid>) - it scopes this find screen
    // to the profile the user came from. Seeded into the search panel rather than applied invisibly,
    // so the filter is visible and the user can clear it.
    const location = useLocation();
    const profileCodeFromUrl = new URLSearchParams(location.search).get("profileCode") || '';

    const initialFormFields = {
        recordNumber: '',
        kittCode: '',
        description: '',
        profileCode: profileCodeFromUrl,
        profileDescription: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    
    // Keep ref in sync with state
    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = '';
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        const buttonUrl = "/wm/codes/edit-item-kit-code?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        // Reload datasource with current formFields to trigger server-side filtering
        let datasource = loadDatasource();
        
        // Build filters including RecordNumber for client-side filtering
        const { IDTYPE, ...filteredFormFields } = formFields;
        const filters = FillFilters(filteredFormFields);
        
        // If no other filters, remove empty filter array
        if (filters.length === 0) {
            datasource.filter(null);
        }
        
        datasource.filter(filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        // Reload datasource with reset fields
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    useEffect(() => {
        // Initialize datasource on mount
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const handleFormLoad = useCallback(() => {
        // Load any lookup data if needed
    }, []);

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    const loadDatasource = () => {
        // Map formFields to ItemKitHeaderFilter structure
        const mapToItemKitHeaderFilter = (fields) => {
            return {
                KittCode: fields.kittCode || '',
                Description: fields.description || '',
                Status: '',
                RowId: null,
                ProfileCode: fields.profileCode || ''
            };
        };

        let store = createStore({
            key: 'RowId',
            loadParams: {
                'filter.KittCode': function() {
                    const filter = mapToItemKitHeaderFilter(formFieldsRef.current);
                    return filter.KittCode;
                },
                'filter.Description': function() {
                    const filter = mapToItemKitHeaderFilter(formFieldsRef.current);
                    return filter.Description;
                },
                'filter.Status': function() {
                    const filter = mapToItemKitHeaderFilter(formFieldsRef.current);
                    return filter.Status;
                },
                'filter.RowId': function() {
                    const filter = mapToItemKitHeaderFilter(formFieldsRef.current);
                    return filter.RowId;
                },
                'filter.ProfileCode': function() {
                    const filter = mapToItemKitHeaderFilter(formFieldsRef.current);
                    return filter.ProfileCode;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.ItemKitHeader.GetItemKitHeaders}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Item Kit Code
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='79C8498D-DADF-459A-A63D-E0CAA24A59C7'
                                layoutName='WMItemKitCodeSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handleEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to="/wm/codes/add-item-kit-code">
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    gridRef={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                        </GridToolbar>
                        <Column dataType="string" caption="Record#" dataField="RecordNumber" />
                        <Column dataType="string" caption="Kit Code" dataField="KittCode" />
                        <Column dataType="string" caption="Description" dataField="Description" />
                        <Column dataType="string" caption="Status" dataField="Status" visible={false} />
                        <Column dataType="string" caption="Profile Code" dataField="ProfileCode"  visible={false}/>
                        <Column dataType="string" caption="Created Date" dataField="CreationDateTime"  visible={false}/>
                        <Column dataType="string" caption="Created By" dataField="CreationUserId"  visible={false}/>
                        <Column dataType="string" caption="Updated Date" dataField="LastUpdateDateTime"  visible={false}/>
                        <Column dataType="string" caption="Updated By" dataField="LastUpdateUserId"  visible={false}/>
                        <Column dataType="string" caption="Profile Description" dataField="ProfileDescription"  visible={false}/>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
